import {
    ISimplePresentation,
    ISimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DjPsycho} from "../DjPsycho";
import {DjPsychoGameMode} from "../server/DjPsychoGameMode";
import {TimelineLite} from "gsap";

export class DjPsychoFSOutroRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        // if mode is any of FS and nextMode is normal
        return (!DjPsycho.model.gameData.brokeBank && (DjPsycho.model.gameData.mode === DjPsychoGameMode.FREESPIN || DjPsycho.model.gameData.mode === DjPsychoGameMode.FREESPIN_AVALANCHE) && DjPsycho.model.gameData.nextMode === DjPsychoGameMode.NORMAL);
    }

    public start(controller: ISimplePresentationRunnerController): void {
        let isFsEnding: boolean = (DjPsycho.model.data.mode == DjPsychoGameMode.FREESPIN_AVALANCHE || DjPsycho.model.data.mode == DjPsychoGameMode.FREESPIN) && DjPsycho.model.data.nextMode == DjPsychoGameMode.NORMAL;

        const tl: TimelineLite = new TimelineLite(),
            currentWinsBetX: number = (isFsEnding ? 6 : 30),
            ratio: number = Math.floor(DjPsycho.model.data.accumulatedRoundWin / DjPsycho.model.data.playedBetValue);

        tl.to(this, {duration: 1});
        tl.add(() => {
            DjPsycho.keypadPlugin.setZeroBetSpinCounter(-1);
            controller.setSkipCallback(() => {
                tl.seek("end", false);

                // #170
                DjPsycho.noWinView.skip();
            });
        });

        let hasWon: boolean = ratio >= currentWinsBetX;
        if (!hasWon) {
            tl.add(DjPsycho.noWinView.showNoWin());
            tl.addLabel("end");
        }
        tl.add(() => {
            controller.setSkipCallback();
        });
        tl.add(DjPsycho.outroView.showOutro(() => this.fsOutroClosedCallback(controller)));
    }

    private fsOutroClosedCallback(controller: ISimplePresentationRunnerController): void {
        controller.finish();
        DjPsycho.buyFeatureName = "";
    }
}